import React from 'react'
import { getHexColor, OneColorIconProps } from '../utils'

export const ParentalControlsBlueIcon: React.FC<OneColorIconProps> = ({ color = '#90E5F6' }) => {
  const hex = getHexColor(color)

  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.1601 3.32514L6.65003 1.15423L1.14 3.32514V4.64253C1.14007 8.13975 3.27927 11.3348 6.65003 12.8393C10.0208 11.3348 12.16 8.13975 12.1601 4.64253V3.32514ZM13.3001 4.64253C13.3 8.65005 10.8312 12.2637 7.02409 13.9221C6.78578 14.026 6.51428 14.026 6.27596 13.9221C2.46888 12.2637 6.40199e-05 8.65005 0 4.64253V3.196C0 2.80573 0.238807 2.4551 0.601917 2.31205L6.30194 0.0661821L6.38655 0.0372366C6.5586 -0.0124123 6.74146 -0.0124121 6.91351 0.0372366L6.99812 0.0661821L12.6981 2.31205C13.0612 2.4551 13.3001 2.80573 13.3001 3.196V4.64253Z"
        fill={hex}
      />
      <path
        d="M9.8807 4.73083C9.88066 4.88933 9.829 5.03338 9.71667 5.14571L6.0933 8.76908C6.03803 8.82428 5.97221 8.86934 5.89513 8.89674C5.86099 8.90899 5.82643 8.91838 5.79123 8.9242L5.68361 8.93311C5.61188 8.93308 5.54068 8.92211 5.47209 8.89748C5.39519 8.87008 5.32915 8.82426 5.27392 8.76908L3.58024 7.07541C3.46679 6.96187 3.4163 6.8157 3.42067 6.65533C3.42539 6.49873 3.47933 6.35626 3.58989 6.24564L3.63294 6.2063C3.73693 6.12161 3.8633 6.08166 4.00032 6.08161C4.15705 6.08171 4.29892 6.13463 4.41001 6.24564L5.68361 7.51924L8.88691 4.31594C8.99921 4.20363 9.14356 4.15204 9.30179 4.15192L9.41757 4.16156C9.53028 4.18135 9.6324 4.23176 9.71667 4.31594C9.82905 4.42831 9.8807 4.5725 9.8807 4.73083Z"
        fill={hex}
      />
    </svg>
  )
}
